import { ProgressAuditBranch, ProgressAuditExitPoint, IProgressAuditTraceFlags } from "../../../features/progressAudit/progressAuditTracesSlice";

export const EXIT_POINT_LABELS: Record<ProgressAuditExitPoint, string> = {
  unauthorized: "Sin autorización",
  created: "Creado",
  certificateError: "Error certificado",
  saved: "Guardado",
  threw: "Excepción",
};

export const BRANCH_LABELS: Record<ProgressAuditBranch, string> = {
  lesson: "Lección",
  topic: "Tópico",
  course: "Curso",
};

export const FLAG_LABELS: Record<keyof IProgressAuditTraceFlags, string> = {
  progressItemExisted: "ya existía",
  lessonCreated: "lección creada",
  topicCreated: "tópico creado",
  lessonFinished: "lección terminada",
  topicFinished: "tópico terminado",
  courseFinished: "curso terminado",
  topicFinishRejected: "tópico NO confirmado",
  courseFinishRejected: "curso NO confirmado",
  evaluationAdded: "evaluación agregada",
  pointsAdded: "puntos sumados",
  pointsError: "error puntos",
  certificateCreated: "certificado creado",
  certificateError: "error certificado",
  saved: "guardado",
};

// Only the flags that actually fired, as short chips - a trace can have
// a dozen boolean flags but usually only two or three are true.
export const getActiveFlagLabels = (flags?: IProgressAuditTraceFlags): string[] => {
  if (!flags) {
    return [];
  }
  return Object.entries(flags)
    .filter(([, value]) => value)
    .map(([key]) => FLAG_LABELS[key as keyof IProgressAuditTraceFlags] || key);
};

// Undefined for a trace that never finished (still "started").
export const formatDurationMs = (durationMs?: number): string | undefined => {
  if (durationMs === undefined || durationMs === null) {
    return undefined;
  }
  if (durationMs < 1000) {
    return `${durationMs}ms`;
  }
  const seconds = durationMs / 1000;
  return `${Number.isInteger(seconds) ? seconds : seconds.toFixed(2)}s`;
};
